export default __webpack_public_path__ + "static/media/logo-texto.0b53031f.svg";